const validationRules = {
	required: (value) =>{
		if(value.input) return { success: true };
		return { success: false, message: " :field is a required field" };
	},
	max: (value) =>{
		// if(!isNaN(value.input) && (parseFloat(value.input) <= parseFloat(value.value))) return { success: true };
		if(typeof value.input === 'string' && (value.input.length <= parseInt(value.value))) return { success: true };
		return { success: false, message: ` :field should contain less than ${parseInt(value.value)} characters` };
	},
	min: (value) =>{
		// if(!isNaN(value.input) && (value.input.length >= parseFloat(value.value))) return { success: true };
		if(typeof value.input === 'string' && (value.input.length >= parseInt(value.value))) return { success: true };
		return { success: false, message: `:field should contain more than ${parseInt(value.value)} characters` };
	},
	email: (value) =>{
		let check = String(value.input)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);

		if(check) return { success: true }
		return { success: false, message: "please enter a valid email address"}
	},
};
export default  validationRules;